// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.content-wrapper{\n  padding: 30px;\n  height: 100%;\n}\n", "",{"version":3,"sources":["webpack://./modules/shared-ui/src/components/content-wrapper/ContentWrapper.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;AACd","sourcesContent":["\n.content-wrapper{\n  padding: 30px;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
